// @generated-imports
import { showToast } from './app.js';
import { CONFIG, state } from './core.js';
import { getSetting } from './platform.js';
import { SESSION_STATUS, isCurrentSession, requestFromSession, sendSessionState } from './session.js';
// @generated-imports
/* ===========================================================================
   VOLTAR NO TEMPO e AVANÇO RÁPIDO (v2.1)
   ---------------------------------------------------------------------------
   O rewind nativo do EmulatorJS varia por core e por build; aqui o portal
   faz o seu, com a mesma ponte de estados que já existe: a cada 5 s de jogo
   um instantâneo vai para um buffer EM MEMÓRIA (máx. 12 ≈ último minuto,
   teto de 32 MB). "Voltar 10/30/60 s" no menu de pausa carrega o instantâneo
   mais próximo. Nada disso é gravado em disco. Desligado no modo leve
   (configuração "Voltar no tempo" = automático).
   Avanço rápido usa o recurso do emulador quando a build o expõe.
   ======================================================================== */

function timelineEnabled() {
  const setting = String(getSetting('rewind') || 'auto');
  if (setting === 'off') return false;
  if (setting === 'on') return true;
  return !state.liteMode;
}

function resetTimeline(session) {
  if (!session) return;
  session.timeline = [];
  session.timelineBytes = 0;
}

function startTimeline(session) {
  stopTimeline(session);
  resetTimeline(session);
  if (!timelineEnabled() || !session.capabilities.state) return false;
  session.timelineTimer = window.setInterval(() => captureTimelineSnapshot(session), CONFIG.timelineIntervalMs);
  return true;
}

function stopTimeline(session) {
  if (session && session.timelineTimer) {
    window.clearInterval(session.timelineTimer);
    session.timelineTimer = 0;
  }
}

async function captureTimelineSnapshot(session) {
  if (!isCurrentSession(session) || session.status !== SESSION_STATUS.PLAYING || session.menuOpen || session.timelineBusy) return;
  session.timelineBusy = true;
  try {
    const data = await requestFromSession(session, { type: 'emutab:save-state', thumbnail: false }, 'emutab:state-saved', 3000);
    if (data && data.ok && data.state) {
      pushTimelineSnapshot(session, { at: Date.now(), bytes: data.state instanceof Uint8Array ? data.state : new Uint8Array(data.state) });
    }
  } finally {
    session.timelineBusy = false;
  }
}

function pushTimelineSnapshot(session, snapshot) {
  if (!session.timeline) resetTimeline(session);
  session.timeline.push(snapshot);
  session.timelineBytes += snapshot.bytes.length;
  while (session.timeline.length > CONFIG.timelineMaxSnapshots
    || (session.timelineBytes > CONFIG.timelineMaxBytes && session.timeline.length > 1)) {
    const old = session.timeline.shift();
    session.timelineBytes -= old.bytes.length;
  }
}

/** Instantâneo mais recente com pelo menos `seconds` de idade (ou o mais antigo). */
function timelineSnapshotFor(session, seconds, now = Date.now()) {
  const list = (session && session.timeline) || [];
  if (!list.length) return null;
  const target = now - seconds * 1000;
  let best = null;
  list.forEach((snap) => { if (snap.at <= target) best = snap; });
  return best || list[0];
}

function timelineAvailableSeconds(session, now = Date.now()) {
  const list = (session && session.timeline) || [];
  return list.length ? Math.max(0, Math.round((now - list[0].at) / 1000)) : 0;
}

async function rewindSession(session, seconds) {
  const snap = timelineSnapshotFor(session, seconds);
  if (!snap) { showToast('Ainda não há pontos para voltar — jogue alguns segundos.'); return false; }
  const ok = await sendSessionState(session, snap.bytes, 6000);
  if (ok) {
    // Pontos "depois" do escolhido deixam de fazer sentido.
    session.timeline = session.timeline.filter((s) => s.at <= snap.at);
    session.timelineBytes = session.timeline.reduce((sum, s) => sum + s.bytes.length, 0);
    showToast(`⏪ Voltou cerca de ${Math.max(1, Math.round((Date.now() - snap.at) / 1000))} s.`);
  } else {
    showToast('O emulador não aceitou voltar no tempo.');
  }
  return ok;
}

/* --- Avanço rápido ------------------------------------------------------- */

async function setFastForward(session, active) {
  if (!session || !session.capabilities.fastForward) return false;
  const data = await requestFromSession(session, { type: 'emutab:fast-forward', active: Boolean(active) }, 'emutab:fast-forward', 3000);
  const ok = Boolean(data && data.ok);
  if (ok) session.fastForward = Boolean(active);
  return ok;
}

// @generated-exports
export { captureTimelineSnapshot, pushTimelineSnapshot, resetTimeline, rewindSession, setFastForward, startTimeline, stopTimeline, timelineAvailableSeconds, timelineEnabled, timelineSnapshotFor };
// @generated-exports
